import React from 'react';

export function PackagingPurchaseOrderPrimaryInfoCard({ isEditing = false }) {
    const placeholderText = isEditing ? 'Not yet implemented (edit mode)' : 'Not yet implemented (view mode)';

    return (
        <div className="rounded-md border bg-card p-6 shadow-sm">
            <div className="flex flex-col gap-6">
                <div className="flex flex-col gap-1">
                    <h2 className="text-left text-lg font-semibold tracking-tight text-foreground">
                        Packaging Purchase Order Information
                    </h2>
                </div>
                <div className="text-sm text-muted-foreground">{placeholderText}</div>
            </div>
        </div>
    );
}

PackagingPurchaseOrderPrimaryInfoCard.displayName = 'PackagingPurchaseOrderPrimaryInfoCard';
